import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPoliciesComponent } from './privacy-policies.component';

@NgModule({
  declarations: [PrivacyPoliciesComponent],
  exports: [PrivacyPoliciesComponent],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
})
export class PrivacyPoliciesModule {}
